import React from 'react';
import { Outlet } from 'react-router-dom';
import { ReactComponent as AppLogo } from '@assets/images/login_logo.svg';
import Footer from '@components/widgets/Footer';

const AuthBrokerLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-grey-50 flex flex-col">
      <div className="auth-layout w-full max-w-[520px] mx-auto flex-1 flex justify-start items-center flex-col overflow-hidden pt-[80px]">
        <div className="relative flex justify-center items-center mb-[80px]">
          <AppLogo />
        </div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default AuthBrokerLayout;